module.exports = __webpack_public_path__ + "img/google-play.b775eda8.svg";